"use client"

import React, { FC } from "react"
import { FragmentType, graphql, useFragment } from "@/gql"
import { JobApplicationStatus } from "@/gql/server"
import { Text } from "@/elements"
import { JobStatusTagStatus, JobStatusTag } from "@/components/JobStatusTag"
import { formatDateDiffDisplay } from "@/utils/formatDateDisplay"
import { JobDetailsFooterViewedBannerFragmentDoc } from "@/gql/graphql"

graphql(`
  fragment JobDetailsFooterViewedBanner on JobApplication {
    __typename
    id
    createdAt
    clientHasInteractedWith
    applicationStatus: status
  }
`)

interface Props {
  jobApplication: FragmentType<typeof JobDetailsFooterViewedBannerFragmentDoc> | undefined | null
}

export const JobDetailsFooterViewedBanner: FC<Props> = props => {
  const jobApplication = useFragment(JobDetailsFooterViewedBannerFragmentDoc, props.jobApplication)

  const hasActiveApplication = jobApplication?.applicationStatus === JobApplicationStatus.Submitted
  const hasInteractedWith = jobApplication?.clientHasInteractedWith

  if (!hasActiveApplication || !hasInteractedWith) {
    return null
  }

  return (
    <div className="flex w-full flex-row items-center justify-between">
      <JobStatusTag showStatusPrefix={false} status={JobStatusTagStatus.Viewed} />
      <Text className="text-fg-2" variant="body2">
        {formatDateDiffDisplay(jobApplication?.createdAt)}
      </Text>
    </div>
  )
}
